import { useTonWallet } from "@tonconnect/ui-react";
import { Link } from "react-router-dom";
import LogoIcon from "../../Icons/LogoIcon";
import TelegramIcon from "../../Icons/TelegramIcon";
import TwitterIcon from "../../Icons/TwitterIcon";
import { FooterMobMenuCol } from "./components/MainFooterMobMenuCol";
import s from "./MainFooter.module.scss";

const socItems = [
  {
    link: "https://t.me/ooiaton",
    icon: <TelegramIcon />,
  },
  {
    link: "https://t.me/ooiatonbot",
    icon: <TelegramIcon />,
  },
  {
    link: "https://x.com/OoiaTon",
    icon: <TwitterIcon />,
  },
  {
    link: "https://t.me/ooiaton_ru",
    icon: <TelegramIcon />,
  },
];

const information = [
  {
    title: "Help center",
    link: "https://t.me/ooia_support_bot",
  },
  {
    title: "GitHub",
    link: "https://github.com/ooiamarketplace",
  },
  {
    title: "Telegram Bot",
    link: "https://t.me/ooiatonbot",
  },
];

const resources = [
  {
    title: "Ton Raffles",
    link: "https://tonraffles.app/swap",
  },
  {
    title: "OOIA NFT Pass",
    link: "/collection/UQB6UvgYAZeVI7F1SSJrbST-cvSGxFtM1BQYEWZ0kTEDcKVL",
  },
  {
    title: "ton.org",
    link: "https://ton.org/",
  },
];

const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const MainFooter: React.FC = () => {
  const wallet = useTonWallet();
  const sections = [
    {
      title: "Collections",
      link: "/rankings",
    },
    ...(wallet
      ? [
          {
            title: "Profile",
            link: `/user/${wallet.account.address}`,
          },
        ]
      : []),
  ];
  return (
    <div className={s.wrapper}>
      <div className={s.top}>
        <div className={s.top_l}>
          <div className={s.info}>
            <Link to="/" className={s.logo}>
              <LogoIcon color="#fff" />
            </Link>
            <div className={s.info_text}>
              An NFT marketplace on the TON network with minimal fees. Your
              perfect tool for profitable and exciting NFT trading without
              losing any funds
            </div>
            <div className={s.socs}>
              {socItems.map((item, i) => (
                <Link to={item.link} className={s.soc} key={i}>
                  {item.icon}
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className={s.top_r}>
          <FooterMobMenuCol title="Sections" items={sections} />
          <FooterMobMenuCol title="Information" items={information} />
          <FooterMobMenuCol title="Resources" items={resources} />
        </div>
      </div>
      <div className={s.bottom}>
        <div className={s.bottom_l}>© {getCurrentYear()} OOIA Marketplace</div>
        <div className={s.bottom_links}>
          <Link target="blank" to="/privacy" className={s.bottom_link}>
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};
